<template>
    <div class="form__item callback-form__mortgage-field" :class="classname" v-click-outside="() => {opened = false}">
        <div class="form__input">
            <input
                v-model.trim="region"
                class="d-input"
                :class="{'_invalid': regionCode === '' && isTrySubmit, '_focus': region.length}"
                type="text"
                name="region"
                autocomplete="off"
                @click="toggle"
                @input='evt=>region=evt.target.value'
                ref="region"
            >
            <label
                    class="form__label p1"
                >
                {{ placeholder }}
            </label>
            <p class="form-error" v-if="regionCode === '' && isTrySubmit">Выберите значение из списка</p>
            <div class="d-select _w-100" :class="{'_opened': opened}">
                    <ul
                        v-show="opened"
                        class="callback-form__regions-list _mt-8 _w-100"
                        ref="scroller"
                    >
                        <li
                            class="d-select__item p1"
                            :key="index"
                            v-for="(item, index) in suggestionItems"
                            :data-code="item.code"
                            @click="chooseSuggestion($event)"
                        >
                            <template>{{ item.title }}</template>
                        </li>
                    </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock';

export default {
    name: "MortgageDevelopersRegion",
    directives: {ClickOutside},
    props: {
        regions: {
            type: Array,
            default: () => {
                return []
            }
        },
        placeholder: {
            type: String,
            default: "",
        },
        classname: {
            type: String,
            default: "",
        },
        isTrySubmit: {
            type: Boolean,
            default: false,
        },
        defaultRegion: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            regionList: [],
            region: '',
            regionCode: '',
            scrollContainer: null,
            opened: false,
            suggestionItems: [],
        }
    },
    methods: {
        toggle() {
            this.opened = !this.opened;
        },
        chooseSuggestion(event) {
            this.region = event.target.textContent.trim();
            this.regionCode = event.target.getAttribute('data-code');
            this.$emit('getRegionCode', this.regionCode);
            this.$nextTick(() => {
                this.opened = false;
            })
        },
        searchRegion() {
            if (this.region.length >= 3) {
                let searchSuggestion = this.$props.regions.filter(val => val.title.toLowerCase().indexOf(this.region.toLowerCase()) !== -1);
                if (searchSuggestion.length > 0) {
                    this.suggestionItems = searchSuggestion;
                }
                else {
                    this.$emit('getRegionCode', '');
                }
            }
            else {
                this.suggestionItems = this.regionList;
                this.regionCode = '';
                this.$emit('getRegionCode', '');
            }
            if (!this.opened) {this.opened = !this.opened}
        },
        checkDefaultRegion() {
            if (this.$props.defaultRegion !== '') {
                this.region = this.$props.defaultRegion;
                this.regionCode = this.regionList[0].const;
                this.$nextTick(() => {
                    this.opened = false;
                })
            }
        }
    },
    watch: {
        regions(val) {
            this.suggestionItems = this.regionList = val;
        },
        region() {
            this.searchRegion();
        },
        opened(isOpen) {
            if (isOpen) {
                disableBodyScroll(this.$refs.scroller, { reserveScrollBarGap: true });
                document.addEventListener('click', this.outsideComboClickListener);
            } else {
                enableBodyScroll(this.$refs.scroller);
                document.removeEventListener('click', this.outsideComboClickListener);
            }
            this.$emit('getRegionOpened', isOpen);
        }
    },
    mounted() {
        this.checkDefaultRegion();
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/base/_variables.scss';
    @import '../../../assets/scss/base/_mixins.scss';
    @import '../../../assets/scss/base/_functions.scss';

    .callback-form__regions-list {
        position: absolute;
        z-index: 1000;
        background-color: $white-101;
        overflow-y: auto;
        @include fluid('max-height', 336px, 250px);
        @include fluid('border-radius', 16px);
        @include fluid('padding-top', 8px);
        @include fluid('padding-bottom', 8px);

        &::-webkit-scrollbar {
            background-color: $grey-109;
            @include fluid('width', 4px);
            @include fluid('margin-right', 8px);
        }

        &::-webkit-scrollbar-track {
            @include fluid('margin-top', 16px);
            @include fluid('margin-bottom', 16px);
        }

        &::-webkit-scrollbar-thumb {
            @include fluid('margin-right', 8px);
            background-color: $grey-166;
            @include fluid('width', 4px);
        }

    }
</style>
